var React = require('react');

function KotlinPlain (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#69c0ff","d":"M1.3 24l11.3-11.5L24 24zM0 0h12L0 12.5zM13.4 0L0 14v10l12-12L24 0z"}));
}

KotlinPlain.defaultProps = {"role":"img","viewBox":"0 0 24 24"};

module.exports = KotlinPlain;

KotlinPlain.default = KotlinPlain;
